import { Icon } from '@nile/components';
import { MainContainer } from '@nile/mangifera/src/Containers/ChatContainers';
import { NewTicketContainer } from '@nile/mangifera/src/Containers/FormContainers';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { AppProvider, Tabs } from '@shopify/polaris';
import { Link } from '@superops/ui-design-system';
import { PlusCircle } from '@styled-icons/boxicons-solid';
import { Close } from '@styled-icons/evaicons-solid';
import { cloneDeep } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import shortid from 'shortid';
import styled from 'styled-components';
import StepNavigation from '../../Components/Public/StepNavigation';
import { ticketNavigations } from '../../Constants/Tickets/index';

const StyledTabsContainer = styled.div`
  height: 100vh;
  overflow: hidden;
`;

function TabContent(tabs, closeTab, content, tab) {
  return (
    <div className="fx tab">
      <span>{content}</span>
      <span className="close">
        <Icon
          style={{
            width: 20,
            height: 20,
            color: 'inherit',
            marginLeft: '75px'
          }}
          icon={Close}
          onClick={closeTab.bind(this, tab)}
        />
      </span>
    </div>
  );
}

class TabsContainer extends Component {
  constructor(props) {
    super(props);
    const { match } = props;
    this.state = {
      selected: 0,
      tabs: [
        {
          id: 'all-tickets',
          content: 'Inbox',
          accessibilityLabel: 'All Tickets',
          panelID: 'all-tickets-content',
          component: (
            <StepNavigation
              data={ticketNavigations}
              pageName={match.params.pagename}
            />
          )
        }
      ],
      activeTab: null
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props?.match?.params?.pagename !== prevProps?.match?.params?.pagename
    ) {
      this.setState({
        tabs: [
          {
            id: 'all-tickets',
            content: 'Inbox',
            accessibilityLabel: 'All Tickets',
            panelID: 'all-tickets-content',
            component: (
              <StepNavigation
                data={ticketNavigations}
                pageName={this.props.match.params.pagename}
                viewtype={this.props.match.params.viewtype}
              />
            )
          }
        ]
      });
    }
  }

  handleTabChange = (index) => {
    const { tabs } = this.state;
    this.setState({ activeTab: tabs[index] });
    this.setState({ selected: index });
  };

  openTicket = (data) => {
    const { tabs } = this.state;
    const { ticketId } = data;
    const tab = {
      id: `ticket-item-${ticketId}`,
      panelID: `ticket-item-content${ticketId}`
    };
    tab.content = TabContent(
      tabs,
      this.closeTab,
      `Ticket #${ticketId.slice(ticketId.length - 5, ticketId.length)}`,
      tab
    );
    tab.component = (
      <MainContainer
        key={ticketId}
        id={ticketId}
        actions={{
          closeTab: this.closeTab,
          openTicket: this.openTicket,
          openTabWithContent: this.openTabWithContent
        }}
        tab={tab}
      />
    );
    tabs.push(tab);
    this.setState({ tabs: tabs }, () => {
      const index = this.state.tabs.length - 1;
      this.setState({ activeTab: this.state.tabs[index] });
      this.setState({ selected: index });
    });
  };

  openTabWithContent = (ticket) => {
    const tabs = cloneDeep(this.state.tabs);
    const { ticketId } = ticket;
    const tab = {
      id: `ticket-item-${ticketId}`,
      panelID: `ticket-item-content${ticketId}`
    };
    tab.content = TabContent(
      tabs,
      this.closeTab,
      `Ticket #${ticketId.slice(ticketId.length - 5, ticketId.length)}`,
      tab
    );
    tab.component = (
      <MainContainer
        key={ticket.ticketId}
        id={ticket.ticketId}
        actions={{
          closeTab: this.closeTab,
          openTicket: this.openTicket,
          openTabWithContent: this.openTabWithContent
        }}
        tab={tab}
      />
    );
    tabs.push(tab);
    this.setState({ tabs: tabs }, () => {
      const index = this.state.tabs.length - 1;
      this.setState({ activeTab: this.state.tabs[index] });
      this.setState({ selected: index });
    });
  };

  componentDidMount() {}

  closeTab = (tab) => {
    const { tabs, selected } = this.state;
    const tabIndex = tabs.findIndex((item) => {
      return item.id === tab.id;
    });
    let selectedIndex = selected;
    if (tabIndex <= selected) {
      selectedIndex -= 1;
    }
    tabs.splice(tabIndex, 1);
    this.setState({ selected: selectedIndex });
    this.setState({ tabs: tabs });
  };

  newTab = () => {
    const { tabs } = this.state;
    const tab = {
      id: `new-item-${tabs.length}`,
      index: tabs.length,
      panelID: `new-item-content${shortid.generate()}`
    };
    tab.content = TabContent(tabs, this.closeTab, 'New Ticket', tab);
    tab.component = (
      <NewTicketContainer
        actions={{ closeTab: this.closeTab, openTicket: this.openTicket }}
        tab={tab}
      />
    );
    tabs.push(tab);
    this.setState({ tabs: tabs }, () => {
      const index = this.state.tabs.length - 1;
      this.setState({ activeTab: this.state.tabs[index] });
      this.setState({ selected: index });
    });
  };

  render() {
    const { selected, activeTab, tabs } = this.state;
    const { actions } = this.props;
    return (
      <AppProvider>
        <TicketContext.Provider
          value={{
            ...actions,
            openTicket: this.openTicket,
            closeTab: this.closeTab,
            activeTab: activeTab
          }}
        >
          <StyledTabsContainer>
            <div id="ticketContainer">
              <Tabs
                tabs={tabs}
                selected={selected}
                onSelect={this.handleTabChange}
                customClassName="ticketing-tabs"
              >
                <div>{tabs[selected].component}</div>
              </Tabs>
            </div>
            <div className="moreTabAction fx actr">
              <div className="new-ticketing-tab">
                <Link onClick={this.newTab} removeUnderline>
                  <Icon
                    style={{ width: 24, height: 24, color: '#FFFFFF' }}
                    icon={PlusCircle}
                  />
                </Link>
              </div>
            </div>
          </StyledTabsContainer>
        </TicketContext.Provider>
      </AppProvider>
    );
  }
}

export default withRouter(TabsContainer);
